const NAMESPACE = "editSensitiveValueDialog";

const KEYS = {
    hideButtonLabel: "hideButtonLabel",
    showButtonLabel: "showButtonLabel",
    newValueLabel: "newValueLabel"
};

const MESSAGES = {
    [KEYS.newValueLabel]: {
        value: "Enter new value:",
        comment: "Label for new value field."
    },
    [KEYS.hideButtonLabel]: {
        value: "Hide",
        comment: "Label for button to hide sensitive data."
    },
    [KEYS.showButtonLabel]: {
        value: "Show",
        comment: "Label for button to show sensitive data."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
